export default defineNuxtRouteMiddleware((to) => {
  const normalized = to.path.replace(/\/+$/, '')
  const isHomepage = /^\/(?:[a-z]{2}(?:-[a-z]{2})?)?$/.test(normalized)
  const routeName = isString(to.name) ? to.name : ''
  const sierraTargetRoutes = ['cart', 'checkout', 'c-slug', 'search', 'p-slug']
  const isTargetRoute = isHomepage || sierraTargetRoutes.includes(routeName)
  const dataRouteName = isTargetRoute ? (isHomepage ? 'home' : routeName) : undefined

  // Inject the body attribute and critical inline CSS during SSR so the
  // hiding rule is in the initial HTML before any scripts execute.
  useHead({
    ...(dataRouteName && {
      bodyAttrs: {
        'data-route-name': dataRouteName
      }
    }),
    style: [{
      key: 'sierra-launcher',
      innerHTML: 'body[data-route-name=home] [data-sierra-launcher]{display:none}'
    }]
  })

  // Direct DOM manipulation for immediate client-side navigation updates
  if (isClient() && document.body) {
    if (dataRouteName)
      document.body.dataset.routeName = dataRouteName
    else
      delete document.body.dataset.routeName
  }
})
